export default class GeoBlockedException extends Error {
    constructor() {
        super('This content is not available in your region');
        this.name = this.constructor.name;
        this.code = 203;
    }
}
